import React, { Component } from "react";
import { Header, Menu, Sticky } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

@observer
class StickyMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { isSticky: false };
  }

  onStick() {
    const { onStick } = this.props;
    this.setState({ isSticky: true });
    onStick && onStick();
  }

  onUnstick() {
    const { onUnstick } = this.props;
    this.setState({ isSticky: false });
    onUnstick && onUnstick();
  }

  render() {
    const { contextRef, hideHeaderWhenIsNotSticky, headerText, subHeader, button, classNames } = this.props;
    const { isSticky } = this.state;

    return (
      <Sticky context={contextRef} onStick={() => this.onStick()} onUnstick={() => this.onUnstick()}>
        <Menu className={`sticky-menu ${classNames} ${isSticky && "sharp-top-corners"}`} secondary={!isSticky}>
          {headerText && (
            <Menu.Item className={hideHeaderWhenIsNotSticky && !isSticky ? "hidden" : ""}>
              <Header as="h2">
                <Header.Content>
                  {headerText}
                  {subHeader}
                </Header.Content>
              </Header>
            </Menu.Item>
          )}
          {button && (
            <Menu.Menu position="right">
              <Menu.Item>{button}</Menu.Item>
            </Menu.Menu>
          )}
        </Menu>
      </Sticky>
    );
  }
}

StickyMenu.propTypes = {
  contextRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  hideHeaderWhenIsNotSticky: PropTypes.bool,
  headerText: PropTypes.string,
  subHeader: PropTypes.element,
  button: PropTypes.element,
  classNames: PropTypes.string,
  onStick: PropTypes.func,
  onUnstick: PropTypes.func,
};

StickyMenu.defaultProps = {
  hideHeaderWhenIsNotSticky: false,
  classNames: "",
};

export default StickyMenu;
